import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, inject, signal } from '@angular/core';
import { SsoRedirectorService } from '../../services/sso-redirector.service';
import { HELIOS_SSO } from 'app/tokens';
import { NavigationExtras, Router } from '@angular/router';
import { HeliosSsoAuthService, IHeliosRolesResponse } from '../../services/helios-sso-auth.service';

import { OrchidModule } from '@upmc-healthplan-npm/ods-ng';
import { assert, assertIsDefined } from 'app/utils/assert';

@Component({
  selector: 'app-helios-sso',
  templateUrl: './helios-sso.component.html',
  styleUrls: ['./helios-sso.component.scss'],
  imports: [OrchidModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeliosSsoComponent implements OnInit {
  private router = inject(Router);

  ssoRedirector = inject(SsoRedirectorService);
  heliosConfig = inject(HELIOS_SSO);
  heliosSsoAuthService = inject(HeliosSsoAuthService);
  protected readonly canAccessHeliosSso = signal(false);

  ngOnInit(): void {
    this.hasHeliosAccess();
  }

  heliosSSO(): void {
    this.ssoRedirector.ssoSamlOutBound(
      this.heliosConfig.idpUrl,
      this.heliosConfig.serviceUrl,
      this.heliosConfig.issuer
    );
  }

  hasHeliosAccess(): void {
    this.heliosSsoAuthService.getHeliosRoles().subscribe((res: IHeliosRolesResponse | null) => {
      assertIsDefined(res, 'Helios roles response must be defined');
      assert(Array.isArray(res.roles), 'Helios roles response must include a roles array');
      this.canAccessHeliosSso.set(res.roles.includes('CanAccessHeliosSso'));
      if (this.canAccessHeliosSso()) {
        setTimeout(() => {
          this.heliosSSO();
          this.router.navigate(['/']);
        }, 3000);
      } else {
        const navigationParams: NavigationExtras = {
          queryParams: { member: 'Unauthorized', pageName: 'access Helios' },
        };
        this.router.navigate(['/unauthorized'], navigationParams);
      }
      (error: any) => error;
    });
  }
}
